import type { Components, Theme } from "@mui/material/styles";

export const MuiButton: Components<Theme>["MuiButton"] = {
  defaultProps: {
    color: "primary",
    size: "large",
    disableElevation: true,
    loadingPosition: "start",
    variant: "contained",
  },

  styleOverrides: {
    root: ({ theme }) => ({
      // add border to all buttons so sizing does not change
      border: `1px solid`,
      borderColor: "transparent",
      borderRadius: theme.shape.borderRadius,
      whiteSpace: "nowrap",
      textTransform: "none",
      lineHeight: 1.375,
      fontWeight: 500,
      letterSpacing: "0.5px",

      "&.Mui-disabled": {
        borderColor: `transparent`,
      },
    }),
    sizeLarge: ({ theme }) => ({
      height: theme.spacing(5),
      padding: theme.spacing(1.125, 2),
      fontSize: "16px",
    }),
    sizeMedium: ({ theme }) => ({
      height: theme.spacing(4),
      padding: theme.spacing(0, 1.5),
      fontSize: "14px",
    }),
    sizeSmall: ({ theme }) => ({
      height: theme.spacing(3),
      padding: theme.spacing(0, 1),
      fontSize: "13px",
    }),
    containedPrimary: ({ theme }) => ({
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    }),
    containedSecondary: ({ theme }) => ({
      borderColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    }),
    outlinedPrimary: ({ theme }) => ({
      borderColor: theme.palette.primary.main,
    }),
    outlined: ({ theme }) => ({
      "&.Mui-disabled": {
        borderColor: theme.palette.text.disabled,
      },
    }),
    textPrimary: () => ({
      borderColor: "transparent",
      "&:hover": {
        mixBlendMode: "multiply",
      },
    }),
    loadingIndicator: ({ theme }) => ({
      variants: [
        {
          props: {
            loadingPosition: "start",
          },
          style: {
            left: theme.spacing(2.75),
            ".MuiButton-sizeSmall &": {
              left: theme.spacing(1.5),
            },
          },
        },
      ],
    }),
  },
};
